import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=46a16394&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=46a16394&prod&lang=less&scoped=true"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=46a16394&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a16394",
  null
  
)

export default component.exports